import React, { ReactElement, useEffect } from 'react';
import { isSome } from 'fp-ts/lib/Option';
import { useReadDashboard } from 'adapter/in/dashboards/hooks/Dashboard/useReadDashboard';
import { useDashboardEdit, dispatchDashboardEdit } from 'adapter/in/dashboards/context/EditDashboard';
import { useReadWidgets } from 'adapter/in/dashboards/hooks/Widgets/useReadWidgets';
import { dispatchWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';
import EditLayoutPage from 'adapter/in/dashboards/pages/EditDashboard/EditLayout';

type EditLayoutContainerProps = {
    id: string;
};

const useEditLayoutContainer = (id: string) => {
    const { isLoading: readDashboardsIsLoading, data, error } = useReadDashboard(id);
    const { setDashboard } = dispatchDashboardEdit();
    const { editLayoutMode } = useDashboardEdit();
    const { isLoading: readWidgetsIsLoading, data: readWidgetsResult, error: readWidgetsError } = useReadWidgets(id);
    const { setWidgets } = dispatchWidgetsView();

    useEffect(() => {
        if (data && isSome(data) && readWidgetsResult && isSome(readWidgetsResult)) {
            setDashboard(data);
            setWidgets(readWidgetsResult.value);
        }
    }, [data, readWidgetsResult]);

    return {
        isLoading: readDashboardsIsLoading || readWidgetsIsLoading,
        data,
        error: isSome(error) ? error : readWidgetsError,
        editLayoutMode,
        hasWidgets: isSome(readWidgetsResult) && readWidgetsResult.value.length > 0,
    };
};

export const EditLayoutContainer = (props: EditLayoutContainerProps): ReactElement => {
    const { id } = props;
    const { editLayoutMode, hasWidgets, error, data, isLoading } = useEditLayoutContainer(id);

    return (
        <EditLayoutPage id={id} editLayoutMode={editLayoutMode} hasWidgets={hasWidgets} error={error} data={data} isLoading={isLoading} />
    );
};

export default EditLayoutContainer;
